import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import {FaXTwitter} from 'react-icons/fa6';

/**
 * Get the icon component for a given platform.
 * @param {string} platform - The platform to get the icon for.
 * @returns {React.ComponentType<any>} - The icon component for the platform.
 */
export const getIconComponent = (platform) => {
    const actionMap = {
        'facebook': FaFacebookF,
        'twitter': FaTwitter,
        'instagram': FaInstagram,
        'youtube': FaYoutube,
        'x': FaXTwitter,
    };
    return actionMap[platform.toLowerCase()] || null;
};